import { ArkivResursData, BildResursData, HTTP_STATUS, RitningResursData, SearchResult } from 'models';

import { DokumentationstypEnum, GenreFormStriktEnum } from 'enums';

import { bebyggelseApiRTK } from 'api/bebyggelseApiRTK';

export type ArkivSearchAdvancedPost = {
  url: string;
  genre_form_strikt: GenreFormStriktEnum;
  kontext_uri: string;
  page: number;
  pagesize: number;
};

export const arkivresursSlice = bebyggelseApiRTK.injectEndpoints({
  endpoints: (build) => ({
    getArkivresurs: build.query<BildResursData | RitningResursData, string>({
      transformErrorResponse(baseQueryReturnValue) {
        return {
          ignoreHttpError: [HTTP_STATUS.NOT_FOUND],
          ...baseQueryReturnValue
        };
      },
      transformResponse: (resursData: ArkivResursData) => {
        const attributes = resursData.attributes;
        const resourceGroup = resursData.resourceGroups?.[0];

        const dokumentationstyp = attributes.find((att) => att.name === 'genre_form_strikt')?.value[0];

        if (
          !dokumentationstyp ||
          (dokumentationstyp !== GenreFormStriktEnum.RITNING && dokumentationstyp !== GenreFormStriktEnum.FOTOGRAFI)
        ) {
          throw new Error('Kan inte hantera dokumentationstyp ' + dokumentationstyp);
        }

        const commonResurs = {
          vinjett: false,
          uri: resursData.uri,
          thumbnailUrl: resourceGroup?.presentationThumbnailUrl,
          url: resourceGroup?.resources?.[0]?.uri || '',
          titel: attributes.find((att) => att.name === 'titel')?.value[0],
          tillkomstdatum: attributes.find((att) => att.name === 'tillkomstdatum_start')?.value[0] || '',
          licensUri: resursData.license.license,
          presentationUrl: resursData.presentationLink
        };

        if (dokumentationstyp === GenreFormStriktEnum.RITNING) {
          return {
            ...commonResurs,
            motivbeskrivning: attributes.find((att) => att.name === 'innehall_beskrivning')?.value[0],
            dokumentationstyp: DokumentationstypEnum.RITNING,
            vy: attributes.find((att) => att.name === 'orientering')?.value[0] || ''
          } as RitningResursData;
        }

        if (dokumentationstyp === GenreFormStriktEnum.FOTOGRAFI) {
          return {
            ...commonResurs,
            bildtext: attributes.find((att) => att.name === 'innehall_beskrivning')?.value[0],
            upphovsman: attributes.find((att) => att.name === 'upphovsman_multi')?.value[0],
            dokumentationstyp: DokumentationstypEnum.BILD,
            vy: attributes.find((att) => att.name === 'orientering')?.value[0] || ''
          } as BildResursData;
        }

        throw new Error('Okänd dokumentationstyp: ' + dokumentationstyp);
      },
      query: (url) => ({
        url,
        method: 'GET'
      }),
      providesTags: ['ArkivResurs']
    }),
    postArkivAdvancedSearch: build.mutation<SearchResult, ArkivSearchAdvancedPost>({
      query: ({ url, genre_form_strikt, kontext_uri, page, pagesize }) => ({
        url,
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          criterias: [
            {
              key: 'genre_form_strikt',
              values: [genre_form_strikt]
            },
            {
              key: 'kontext_uri',
              values: [kontext_uri]
            }
          ],
          contentOption: 'includeAll',
          page,
          pagesize
        })
      })
    })
  })
});

export const { usePostArkivAdvancedSearchMutation, useLazyGetArkivresursQuery } = arkivresursSlice;
